import React, { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { State, useAppDispatch } from "../../../../../state/store";
import { getListAction, openDialogAction } from "../../../../../state/usecase/disease_knowledge/actions";
import { useDiseaseCategories } from "../../../../hooks/disease_knowledge/useDiseaseCategories";
import { DiseaseKnowledgeListItem } from "./DiseaseKnowledgeListItem";
import { Supervisior } from "./Supervisior";

export const DiseaseKnowledgeList = React.memo(function DiseaseKnowledgeList() {
    const dispatch = useAppDispatch();

    const dialogMode = useSelector((state: State) => state.diseaseKnowledge.dialogMode);

    const openDetailDialogButton = useCallback((diseaseId: string) => () => {
        dispatch(openDialogAction({ diseaseId }));
    }, [dispatch]);

    const diseaseCategories = useDiseaseCategories();

    useEffect(() => {
        dispatch(getListAction());
    }, [dispatch, dialogMode]);
    
    return (
        <ul className={"disease_categories"}>
            {!!diseaseCategories && diseaseCategories.map(category => (
                <DiseaseKnowledgeListItem key={category.id} category={category} openDetailDialogButton={openDetailDialogButton} />
            ))}
            <Supervisior />
        </ul>
    );
});
